/**
 * alarmCatalogPanel — visibilidad de la "chuleta de alarmas" (panel de
 * consulta de códigos). El botón que la abre vive en el header (App.tsx),
 * el panel se renderiza dentro de SantaColomaMapView — store compartido
 * para no acoplar ambos componentes.
 */
import { create } from 'zustand';

interface AlarmCatalogPanelState {
  open: boolean;
  toggle: () => void;
  close: () => void;
}

export const useAlarmCatalogPanel = create<AlarmCatalogPanelState>((set) => ({
  open: false,
  toggle: () => set(s => ({ open: !s.open })),
  close: () => set({ open: false }),
}));
